import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ReactNode } from 'react';
import { Colors } from 'dg-web-shared/ui/vars.ts';

export function ToggleGroup<V extends string | number>({
    value,
    onChange,
    valueRenders,
}: {
    value: V;
    onChange: (value: V) => void;
    valueRenders: { value: V; description: ReactNode }[];
}) {
    return (
        <ToggleButtonGroup
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'stretch',
            }}
            exclusive
            value={value}
            onChange={(_, value) => onChange(value as V)}
        >
            {valueRenders.map(({ value, description }) => (
                <ToggleButton
                    key={value}
                    value={value}
                    sx={{
                        flex: 1,
                        height: '100%',
                        minHeight: 'auto',
                        py: 0, // kill extra vertical padding
                        color: Colors.darkblue,
                        backgroundColor: Colors.white,
                        '&.Mui-selected': {
                            color: Colors.white,
                            backgroundColor: theme => theme.palette.blue.main,
                            '&:hover': {
                                color: Colors.white,
                                backgroundColor: theme =>
                                    theme.palette.blue.electric,
                            },
                        },
                        '&:hover': {
                            color: Colors.white,
                            backgroundColor: theme =>
                                theme.palette.blue.electric,
                        },
                    }}
                >
                    {description}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}
